import { classNames } from 'primereact/utils';
import type { contentHeaderButtonProps } from '../../../models/contentHeaderButtonProps';
import SmallLoader from '../../loaders/SmallLoader';

// Компонент - кнопка действия в шапке для контент-поля.
export function ContentHeaderButton({ imageSrc, name, active, addClassName, onClick, isLoading }: contentHeaderButtonProps) {
    let contentHeaderButtonClassName = classNames(addClassName, {
        "content-header-button-div": true,
        "active": active
    })
    return (
        <div className={contentHeaderButtonClassName} title={name} onClick={onClick}>
            {isLoading
                ?
                <SmallLoader />
                :
                <img src={imageSrc} alt="button-icon" className="content-header-button-icon" />
            }
        </div>
    );
}

